<template>
    <div class="advertise">
        <div class="title" @click="changShow">
            <span>客服</span>
            <Icon type="ios-arrow-up" v-if="!isShow" />
            <Icon type="ios-arrow-down" v-else />
        </div>
        <div v-if="isShow" style="margin-top: 5px;">
            <div class="advertise-item" v-for="(item, index) in kfList" :key="index">
                <span>{{ item.text }}</span>
                <div @click="toCopy(item.tel, item.text)">
                    {{ item.tel }}
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            kfList: [{
                text: this.$t('common.kf'),
                tel: '15859789019'
            },{
                text: this.$t('common.wx'),
                tel: 'Zzn1121562373'
            },{
                text: this.$t('common.line'),
                tel: '11251562373'
            }],
            isShow: true
        }
    },
    methods: {
        toCopy(tel, text) {
            this.$clipboard(tel)
            this.$Message.success(`成功複製${text}`);
        },
        changShow() {
            this.isShow = !this.isShow
        }
    }
}
</script>
<style scoped lang="scss">
.title {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    cursor: pointer;
}
.advertise {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translate(0, -50%);
    padding: 12px 12px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    background-color: #fff;
    border-radius: 12px;

    .advertise-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        color: #333;
        margin-bottom: 12px;

        div {
            text-decoration: underline;
            cursor: pointer;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/layout/advertisement/index.vue